<template>
    <div class="content-wrap">
        <mq-layout mq="mobile">
            <MobileFrame @click-cn-androiddownload="handleClickAndroidDownload"></MobileFrame>
        </mq-layout>
        <mq-layout mq="laptop">
            <LaptopFrame @click-cn-androiddownload="handleClickAndroidDownload"></LaptopFrame>
        </mq-layout>
        <mq-layout mq="wide">
            <WideFrame @click-cn-androiddownload="handleClickAndroidDownload"></WideFrame>
        </mq-layout>
        <modal name="cn-android-downloadAlert"
            :classes="'msgPopup'"
            :clickToClose="false"
            :width="500"
            :height="'auto'">
            <div class="popup" align="center">
                <div class="content">
                    <pre class="popupTitle">{{popupTitle}}</pre>
                    <pre class="popupDesc1">{{popupDesc1}}</pre>
                    <pre class="popupDesc2">{{popupDesc2}}</pre>
                    <pre class="popupDesc2">{{popupDesc3}}</pre>
                </div>
                <button @click="handleClickGoDownload" class="okbutton" align="center">
                    {{ popupButton }}
                </button>
                <div class="close" @click="handleClickCloseModal" >
                    <img src="@/assets/home/icon-close-btn-m.svg" />
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import WideFrame from "./HomeWide"
import LaptopFrame from "./HomeLaptop"
import MobileFrame from "./HomeMobile"
import { isAndroid, getUA } from 'mobile-device-detect'

export default {
    name: "home",
    components: { WideFrame, LaptopFrame, MobileFrame },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            l10: l10n,
            popupTitle: '',
            popupDesc1: '',
            popupDesc2: '',
            popupDesc3: '',
            popupButton: '',
            downloadUrl: this.$store.state.cnDownloadUrl,
            isAndroid: isAndroid,
            isWechatBrowser: getUA.toLowerCase().indexOf('micromessenger') > -1,
        };
    },
    /*
    created() {
        if (this.$route.query.appid != undefined || this.$route.query.appurl != undefined || this.$route.query.appver != undefined) {
            this.$router.replace('')
        }
    },
    */
    methods: {
        goDownload() {
            // console.log('go download')
        },
        handleClickAndroidDownload() {
            this.popupTitle = this.l10.Cn_Main_Body_Download_Android_Popup_Title + ' ' + this.$store.state.appVersion
            this.popupDesc1 = this.l10.Cn_Main_Body_Download_Android_Popup_Description1
            this.popupDesc2 = this.l10.Cn_Main_Body_Download_Android_Popup_Description2
            this.popupDesc3 = this.l10.Cn_Main_Body_Download_Android_Popup_Description3
            this.popupButton = this.l10.Cn_Main_Body_Download_Buttn_Name
            this.$modal.show('cn-android-downloadAlert');
        },
        handleClickGoDownload() {
            this.$modal.hide('cn-android-downloadAlert');
            if (isAndroid) {
                var self = this
                window.setTimeout(function() {
                    window.location.href = self.downloadUrl;
                }, 100)
            } else {
                window.open(this.downloadUrl, '_blank')
            }
        },
        handleClickCloseModal() {
            this.$modal.hide('cn-android-downloadAlert');
        }
    }
};
</script>
<style src="@/assets/account/main.css"></style>
<style scoped>
.content-wrap {
    position: relative;
    min-width: 100%;
}
.popup {
    top: 50%;
    margin-top: -160px;
    position: fixed;
    width: 500px;
}

.popup .content {
    width: 100%;
}

.popupTitle {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
}

.popupDesc1 {
    font-size: 18px;
    margin-bottom: 15px;
}

.popupDesc2 {
    font-size: 15px;
    color: #42c0ff;
}

.close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue